/* Stickerheads OS 2.0 - prevent XCloud/Cloud Search from attaching to this unpublished theme only. */
(function(){'use strict';
var kill=function(){
  document.querySelectorAll('#cloud_search_filters_root,[id*="cloud_search" i],[class*="cloud_search" i],[id*="cloudsearch" i],[class*="cloudsearch" i]').forEach(function(el){if(!el.closest('.sh-header__search')) el.remove();});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',kill);else kill();
new MutationObserver(kill).observe(document.documentElement,{childList:true,subtree:true});
})();